import { removeAttachedService } from './attachedServices';
import { filterAndMapAttributes } from '@jbhi-fi/apis/src/utils/filterAndMapAttributes';
import { ShopifyStorefrontClient } from '../../api/shopify/ShopifyStorefrontClient';
import { updateCart, setCartLoading } from './cartUtils';
import { ServiceIds } from '../constants/services';

const storefrontClient = new ShopifyStorefrontClient();

export const removeAttachedServiceOffering = async (
  attachedServiceLineIdOrIds: string | Array<string>,
  serviceLink?: string
) => {
  try {
    if (serviceLink) {
      setCartLoading(true);

      let cart = await storefrontClient.removeFromCart(attachedServiceLineIdOrIds);
      const hasRemainingAttachedServices = cart?.items.some(
        item => item.properties?._serviceLink === serviceLink && item.properties?._isAttachedService === 'true'
      );
      const hasRemainingInstallServices = cart?.items.some(
        item =>
          item.properties?._serviceLink === serviceLink &&
          item.properties?._isAttachedService === 'true' &&
          item.properties?._serviceType === ServiceIds.Install
      );
      const primaryItem = cart?.items.find(item => item.properties._serviceLink === serviceLink);
      if (!hasRemainingAttachedServices) {
        removeAttachedService(serviceLink);

        if (primaryItem) {
          delete primaryItem.properties?._serviceLink;
          delete primaryItem.properties?._isAttachedService;
          delete primaryItem.properties?._legacy_addons_line_key;
          delete primaryItem.properties?._hasInstallation;
          cart = await storefrontClient.updateCartLine(
            primaryItem.line_id,
            undefined,
            filterAndMapAttributes(primaryItem.properties)
          );
        }
      } else if (primaryItem && !hasRemainingInstallServices) {
        primaryItem.properties._hasInstallation = 'false';
        cart = await storefrontClient.updateCartLine(
          primaryItem.line_id,
          undefined,
          filterAndMapAttributes(primaryItem.properties)
        );
      }

      await updateCart(cart);
    }
  } catch (e) {
    console.error(e);
  }
};
